/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteWorkList
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete work list
 *
 */
interface IProps {
	entityType: ClaimWorkLists.IWorkListEntityType;
	id: string;
}
const useDeleteWorkList = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ entityType, id }) => {
			await api.WorklistApi.deleteWorklist({ entityType, worklistId: id });
		},
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimWorkLists] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteWorkList;
